import { capitalize } from 'lodash'
import React, { FC, useCallback, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useDispatch, useSelector } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { get } from 'src/apis/apiService'
import routes from 'src/routes'
import { ON_DEMAND_APIS } from '../../../apis/onDemandApi'
import { appendOrals, initialAbstractState, setPageTitle, setPreviousPage } from '../../../ducks/onDemand'
import { MOBILE_THRESHOLD } from '../../../styles/theme'
import { useWindowSize } from '../../../utils/useWindowSize'
import LoadIcon from '../../LoadIcon'
import { Loader } from '../../shared/Loader'
import { ListItem } from './ListItem'

export const OralAbstractList: FC<RouteComponentProps> = ({ match }) => {
  const areaOfInterest = match.params['areaOfInterest']
  const dispatch = useDispatch()
  const [pageLoading, setPageLoading] = useState<boolean>(false)
  const { orals } = useSelector((state) => state.onDemand)
  const { windowWidth, windowHeight } = useWindowSize()

  const currentAreaOrals = orals[areaOfInterest] ?? initialAbstractState

  const fetchOrals = useCallback(() => {
    get(
      ON_DEMAND_APIS.ORALS,
      (data) => {
        setPageLoading(false)
        dispatch(
          appendOrals(areaOfInterest, {
            abstracts: data.abstracts,
            totalPages: data.total_pages,
          })
        )
      },
      (error) => {
        setPageLoading(false)
        console.error(error)
      },
      {
        page: currentAreaOrals.currentPage || 1,
        area_of_interest: areaOfInterest,
      }
    )
  }, [areaOfInterest, currentAreaOrals.currentPage, dispatch])

  useEffect(() => {
    dispatch(setPreviousPage(routes.onDemandOral))
  }, [dispatch])

  useEffect(() => {
    dispatch(setPageTitle(areaOfInterest))
    if (!currentAreaOrals.fetchedInitial) {
      setPageLoading(true)
      fetchOrals()
    }
  }, [areaOfInterest, currentAreaOrals.fetchedInitial, dispatch, fetchOrals, orals])

  const infiniteScrollHeight = windowHeight - (windowWidth <= MOBILE_THRESHOLD ? 120 : 110)

  return (
    <Loader fullPage loading={pageLoading}>
      <InfiniteScroll
        height={infiniteScrollHeight}
        dataLength={currentAreaOrals.abstracts.length}
        next={fetchOrals}
        hasMore={!pageLoading && currentAreaOrals.currentPage < currentAreaOrals.totalPages + 1}
        loader={
          <div className="position-relative my-5">
            <LoadIcon />
          </div>
        }
        endMessage={<p className="text-center text-muted">-- End --</p>}
        scrollThreshold={0.9}
      >
        <>
          {currentAreaOrals.abstracts.map((poster) => (
            <ListItem key={poster.id} abstractType="oral" title={poster.title} subtitle={capitalize(poster.presenting_author_name)} abstractId={poster.id} />
          ))}
        </>
      </InfiniteScroll>
    </Loader>
  )
}
